import React, { Component } from "react";

export default class Frontpage extends Component {
  render() {
    return (
      <div>
        <h2>Frontpage</h2>
      </div>
    );
  }
}
